import { capitalize } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../components/buttons/ButtonComponent/ButtonComponent.vue.js';
import { getRoute } from '../../../../../router/helpers/initRouter.js';

var script = defineComponent({
    name: 'VisitTypeTabs',
    components: {
        ButtonComponent: __vue_component__,
    },
    setup() {
        const route = getRoute();
        const initVisitTypeTab = (id) => ({
            id,
            title: capitalize(id),
        });
        const visitTypeTabs = computed(() => [
            initVisitTypeTab('home'),
            initVisitTypeTab('lab'),
        ]);
        const activeTabID = computed(() => {
            const { visitType } = route.value.params;
            return (visitType !== null && visitType !== void 0 ? visitType : 'home');
        });
        const getClassNamesByTabID = (tabID) => {
            if (activeTabID.value === tabID)
                return ['VisitTypeTabs__tab--active'];
            return [];
        };
        const getTabRoute = (tabID) => ({
            params: { visitType: tabID },
        });
        return {
            activeTabID,
            visitTypeTabs,
            getClassNamesByTabID,
            getTabRoute,
        };
    },
});

export { script as default };
